<button
  class="bullet"
  [ngClass]="{'selected': selected}">
</button>
